// Modules
import { connect } from 'react-redux';
import React from 'react';
import _ from 'lodash';

import { RawField, TextInput } from 'components/forms/form-elements';

class CompanySelector extends React.Component {
  constructor() {
    super();

    this.state = {};
    this.selectCompany = this.selectCompany.bind(this);
    this.search = (event) => this.setState({ search: event.target.value });
    this.clearSearch = () => this.setState({ search: null });
  }

  selectCompany(company) {
    this.clearSearch();
    this.props.onSelect(company);
  }

  render() {
    const { companies } = this.props;
    const { search } = this.state;
    
    const filteredCompanies = _.filter(companies, ({ name, nickname, companyType }) => {
      if (companyType !== 'Client') return false;
      if (!search) return true;

      const normalizedName = _.toLower(name + nickname);
      const normalizedSearch = _.toLower(search);

      return _.includes(normalizedName, normalizedSearch);
    });

    const scrollableStyles = {
      height: '300px',
      overflowY: 'scroll',
      width: '250px'
    };

    return (
      <div>
        <div className="p-2"><RawField autoFocus elementClasses="mb-0" onChange={this.search} component={TextInput} /></div>
        <div className="border-rounded" style={scrollableStyles}>
          <div className="list-group list-group-flush">
            { _.map(filteredCompanies, companyItem =>
              <a
                className="list-group-item list-group-item-action"
                key={companyItem.id}
                onClick={() => this.selectCompany(companyItem)}
              >{companyItem.nickname}</a>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ companies: state.pageData.selectCompanies }))(CompanySelector);



// WEBPACK FOOTER //
// ./app/components/widgets/selectors/company-selector.js